import { createApp } from 'vue'
import App from './App.vue'

import '@/assets/styles/app.css'

createApp(App).mount('#app')
